import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TotpLoginRequest, TotpLoginResponse } from '../model';

@Injectable()
export class TotpService {
  private httpClient = inject(HttpClient);

  private url: string = '/totp/Employee/login';

  public login(request: TotpLoginRequest, id: string) {
    return this.httpClient.post<TotpLoginResponse>(this.url, request, { headers: this.getHeaders(id) });
  }

  private getHeaders(id: string): HttpHeaders {
    return new HttpHeaders().set('xhr', 'true').set('id', id);
  }
}
